import { createAction } from 'redux-act';

/**
 * Create the action
 */

export const subjectUpdate = createAction('NEW_USER_SUBJECT_SUBJECT_UPDATE');
export const subjectAbbreviationUpdate = createAction('NEW_USER_SUBJECT_SUBJECT_ABBREVIATION_UPDATE');
export const colorUpdate = createAction('NEW_USER_SUBJECT_COLOR_UPDATE');
export const teacherUpdate = createAction('NEW_USER_SUBJECT_TEACHER_UPDATE');
export const teacherAbbreviationUpdate = createAction('NEW_USER_SUBJECT_TEACHER_ABBREVIATION_UPDATE');
export const newUserSubjectLoad = createAction('NEW_USER_SUBJECT_LOAD_DATA');
export const newUserSubjectClear = createAction('NEW_USER_SUBJECT_CLEAR');

export function subject(subject) {
    return subjectUpdate({
        subject
    });
}

export function subjectAbbreviation(abbreviation) {
    return subjectAbbreviationUpdate({
        abbreviation
    });
}

export function color(color) {
    return colorUpdate({
        color
    });
}

export function teacher(teacher) {
    return teacherUpdate({
        teacher
    });
}

export function teacherAbbreviation(abbreviation) {
    return teacherAbbreviationUpdate({
        abbreviation
    });
}

export function loadNewUserSubject(userSubject) {
    return newUserSubjectLoad({
        ...userSubject,
    });
}

export function subjectClear() {
    return newUserSubjectClear();
}